<script setup lang="ts">
import { inject, ref } from 'vue'
import { useThreadsStore } from '../stores/threads'
import { routeShellDrawersKey } from './RouteShell.vue'

// The Today page's "Ask the brain" box. Asking starts a fresh thread
// and opens the Ask drawer, which streams the answer — the same path
// the drawer's own composer takes, just started from the home page.
const threads = useThreadsStore()
const drawers = inject(routeShellDrawersKey, undefined)
const question = ref('')

function ask(): void {
  const text = question.value.trim()
  if (!text) return
  threads.reset()
  drawers?.openThreads()
  question.value = ''
  // The drawer renders `submitError`; nothing more to do with a failure here.
  threads.submit(text).catch(() => {})
}
</script>

<template>
  <form
    class="flex flex-col gap-3 rounded-2xl border border-border-control bg-surface-raised px-4 pt-4 pb-3 focus-within:border-brand-primary sm:px-5"
    data-testid="today-ask"
    @submit.prevent="ask"
  >
    <label for="today-ask-input" class="text-xs font-semibold uppercase tracking-[0.08em] text-brand-primary">
      Ask the brain
    </label>
    <input
      id="today-ask-input"
      v-model="question"
      type="text"
      autocomplete="off"
      placeholder="What did I decide about hybrid retrieval?"
      class="border-0 bg-transparent p-0 text-lg text-ink outline-none placeholder:text-ink-faint"
    />
    <div class="flex items-center gap-2">
      <span class="flex-1 text-xs text-ink-faint">Starts a new thread · answers cite wiki pages</span>
      <button
        type="submit"
        data-testid="today-ask-submit"
        :disabled="!question.trim()"
        class="min-h-10 rounded-[10px] bg-brand-primary px-5 font-semibold text-[#0b1f17] disabled:cursor-not-allowed disabled:opacity-50"
      >
        Ask
      </button>
    </div>
  </form>
</template>
